import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-index-card-1',
  imports: [MatCardModule, MatButtonModule, MatIconModule],
  templateUrl: './index-card-1.component.html',
  styleUrl: './index-card-1.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndexCard1Component {
  experience = '23+ years in IT · 6+ years in DevOps';
  summary = 'I design and operate multi-cloud infrastructures, automate CI/CD pipelines, and help engineering teams ship reliably using Infrastructure as Code and container orchestration.';
  specialties = ['Multi-Cloud (AWS · GCP · Azure)', 'Infrastructure as Code', 'CI/CD Automation', 'Kubernetes & Docker'];
  linkedIn = 'https://www.linkedin.com/in/oleh-rumyk-a13659219/';
  platform = 'https://platform.rumyk.click/index';
}
